import { useEffect, useRef } from 'react';
import { startChangeFeed, type ChangeFeedPage, type ChangeFeedWatch } from '../services/changeFeed';

/**
 * Engancha una pantalla al latido de cambios (2026-09-10). `watch` y `onPage`
 * se leen por referencia en cada latido: la pantalla puede cambiar de día o
 * de cargas sin reiniciar nada, y la función de refresco puede ser la última
 * sin que el efecto dependa de ella. Con `enabled` a false no late.
 */
export function useChangeFeed(watch: ChangeFeedWatch, onPage: (page: ChangeFeedPage) => void, enabled = true): void {
  const watchRef = useRef(watch);
  const onPageRef = useRef(onPage);
  watchRef.current = watch;
  onPageRef.current = onPage;

  useEffect(() => {
    if (!enabled) return;
    const handle = startChangeFeed(() => watchRef.current, (page) => onPageRef.current(page));
    return () => handle.stop();
  }, [enabled]);
}
